export default "__VITE_ASSET__BwHymEkq__"